// EmotionColorStrategy.js
export class EmotionColorStrategy {
  constructor(colorPorEmocion) {
    this.colorPorEmocion = colorPorEmocion;
  }

  getColor(emotion) {
    return this.colorPorEmocion[emotion] || null;
  }

  updateColor(emotion, colorKey) {
    this.colorPorEmocion[emotion] = colorKey;
  }

  resetColors() {
    this.colorPorEmocion = {};
  }
}
